var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.audioData.length)?_c('ActivityAudio',{key:_vm.key,attrs:{"data":_vm.audioData,"meta":{ timeout: 1 }}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }